<div class="form-group">
  <label for="prod-m">{{ 'form.card_withdrawal'| translate }}</label>
  <angular2-multiselect [data]="withdrawalList"
      [(ngModel)]="withdrawalSelected"
      [settings]="multiselectSettings[EMULTI_SELECT_SETTING.NO_SEARCH]"
      (onSelect)="onWithdrawalSelect()">
  </angular2-multiselect>
</div>